<div class="modalBase w-100 recover-password-modal">
  <span class="btn_Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </span>

  <div class="recover-password-modal__body">
    <div class="text-center mb-4">
      <span class="titulo">Recuperar contraseña</span>
    </div>

    <form
      class="recover-password-form"
      [formGroup]="recoverPasswordForm"
      (submit)="onSubmit()"
    >
      <p class="recover-password-form__hint">
        Ingresa tu correo electrónico y te enviaremos una contraseña temporal.
        Al ingresar deberás establecer una nueva.
      </p>

      <div class="form-field">
        <label class="labeltext" for="recover-email">Correo electrónico</label>
        <input
          id="recover-email"
          type="email"
          class="input_tx"
          placeholder="Correo electrónico"
          formControlName="email"
          autocomplete="email"
          (blur)="normalizeEmail()"
        />
        @if (
          recoverPasswordForm.controls.email.touched &&
          recoverPasswordForm.controls.email.errors?.required
        ) {
          <div class="texterror">Correo requerido</div>
        }
        @if (
          recoverPasswordForm.controls.email.touched &&
          recoverPasswordForm.controls.email.errors?.email
        ) {
          <div class="texterror">Correo inválido</div>
        }
      </div>

      @if (errorMessage) {
        <ngb-alert class="mb-3" type="danger" (close)="errorMessage = ''">
          {{ errorMessage }}
        </ngb-alert>
      }
      @if (successMessage) {
        <ngb-alert class="mb-3" type="success" (close)="successMessage = ''">
          {{ successMessage }}
        </ngb-alert>
      }

      <div class="recover-password-form__actions">
        <button
          type="button"
          class="btn btn-outline-secondary rounded-pill px-4"
          (click)="activeModal.dismiss('Close clicked')"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-recover-submit rounded-pill px-4 font-weight-bold"
          [disabled]="!recoverPasswordForm.valid || submitting"
        >
          Recuperar
        </button>
      </div>
    </form>
  </div>
</div>
